import { FilterChips } from 'cdk-radial';
import styled from 'styled-components';

export const StyledDiv = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledSpan = styled.span`
  margin: 0px 10px 0 20px;
  width: 2.5rem;
`;

export const StyledFilterChips = styled(FilterChips)`
  padding-top: 5px;
  width: 500px;
  svg {
    border: 1px solid rgba(21, 27, 37, 0.25);
    left: 10px;
  }
`;
